export default "__VITE_ASSET__Bb0RPRhL__"